module.exports = __webpack_public_path__ + "static/media/dimentha-strategy.6d4fd469.svg";